import addTwo from './2.svg?url';
import addThree from './3.svg?url';
import addFour from './4.svg?url';
import addTwoWarning from './2-warning.svg?url';
import addThreeWarning from './3-warning.svg?url';
import addFourWarning from './4-warning.svg?url';

export const getImageAdd = (nbrOfInputs: number, hasFlow = true) => {
  switch (nbrOfInputs) {
    case 2:
      return hasFlow ? addTwo : addTwoWarning;
    case 3:
      return hasFlow ? addThree : addThreeWarning;
    case 4:
      return hasFlow ? addFour : addFourWarning;
    default:
      return hasFlow ? addTwo : addTwoWarning;
  }
};
